var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 12.25H1.6C0.854071 12.25 0.25 11.6459 0.25 10.9V2.1C0.25 1.35407 0.854071 0.75 1.6 0.75H16.8C17.5459 0.75 18.15 1.35407 18.15 2.1V10.9C18.15 11.6459 17.5459 12.25 16.8 12.25Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39844 8.5H5.59844",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39844 10.0996H9.59844",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 7.9502C13.3533 7.9502 13.4977 7.98777 13.6265 8.0543C13.4539 8.29097 13.35 8.58189 13.35 8.9002C13.35 9.2185 13.4539 9.50942 13.6265 9.74609C13.4977 9.81262 13.3533 9.8502 13.2 9.8502C12.6757 9.8502 12.25 9.42452 12.25 8.9002C12.25 8.37587 12.6757 7.9502 13.2 7.9502Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39844 6.09961H3.99844",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60156 6.09961H7.20156",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80078 6.09961H10.4008",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7516 8.9002C15.7516 9.42452 15.3259 9.8502 14.8016 9.8502C14.2772 9.8502 13.8516 9.42452 13.8516 8.9002C13.8516 8.37587 14.2772 7.9502 14.8016 7.9502C15.3259 7.9502 15.7516 8.37587 15.7516 8.9002Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.f8bb2a702b066dcb2937ef5ad951acb6.svg";
export { ForwardRef as ReactComponent };